<div id="partner" class="partner-area ptb-100 bg-fffdfd">
    <div class="container">
        <div class="partner-slides">
            @if (languageService.currentLang(); as lang) {
            <owl-carousel-o [options]="partnerSlides">
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#contact" class="partner-item-link" (click)="onClick('contact'); $event.preventDefault()" [attr.aria-label]="'partner.goTo' | translate:{country: ('partner.venezuela' | translate)}">
                            <img src="assets/images/pafar_vzla.png" [attr.alt]="'partner.altVzla' | translate">
                            <span>{{ 'partner.venezuela' | translate }}</span>
                        </a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#contact" class="partner-item-link" (click)="onClick('contact'); $event.preventDefault()" [attr.aria-label]="'partner.goTo' | translate:{country: ('partner.panama' | translate)}">
                            <img src="assets/images/pafar_panama.png" [attr.alt]="'partner.altPanama' | translate">
                            <span>{{ 'partner.panama' | translate }}</span>
                        </a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#contact" class="partner-item-link" (click)="onClick('contact'); $event.preventDefault()" [attr.aria-label]="'partner.goTo' | translate:{country: ('partner.nicaragua' | translate)}">
                            <img src="assets/images/solinte_nicaragua.png" [attr.alt]="'partner.altNicaragua' | translate">
                            <span>{{ 'partner.nicaragua' | translate }}</span>
                        </a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#contact" class="partner-item-link" (click)="onClick('contact'); $event.preventDefault()" [attr.aria-label]="'partner.goTo' | translate:{country: ('partner.dominican' | translate)}">
                            <img src="assets/images/pafar_rd.png" [attr.alt]="'partner.altDominican' | translate">
                            <span>{{ 'partner.dominican' | translate }}</span>
                        </a>
                    </div>
                </ng-template>
                <!--<ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/images/global_solution.png" alt="partner"></a>
                        <span>WWW</span>
                    </div>
                </ng-template>-->
                <!--<ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-6.png" alt="partner"></a>
                    </div>
                </ng-template>
                
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-1.png" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-2.png" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-3.png" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-4.png" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-5.png" alt="partner"></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"><img src="assets/img/partner-6.png" alt="partner"></a>
                    </div>
                </ng-template>-->
            </owl-carousel-o>
            }
        </div>
    </div>
</div>